var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,100) scale(0.1,-0.1)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193 935 c-35 -16 -121 -98 -132 -127 -12 -33 6 -117 39 -183 70 -140 271 -358 430 -464 99 -66 210 -108 258 -96 31 7 129 106 144 144 5 14 7 35 4 47 -7 25 -197 154 -228 154 -10 0 -41 -11 -68 -25 -27 -14 -52 -25 -56 -25 -9 0 -192 180 -215 212 -19 26 -19 26 6 70 37 65 33 86 -41 197 -70 106 -89 118 -141 96z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.97144e663071b9a185055aa5e0aba392.svg";
export { ForwardRef as ReactComponent };